import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import URLs from '../../../../../utils/appURLs';
import { updateToast } from '../../../../../common/redux/reducer/commonSlices/toastSlice';
import axiosInstance from '../../../../../app/config/axiosInstance';
import { deliveryTrackingURLs } from '../../../utils/deliveryTrackingURLs';
import { count } from 'console';

const initialState = {
  isLoading: false,
  data: [],
  error: null,
  count: null
};

const initialStateAddOrder = {
  isLoading: false,
  data: [],
  error: null,
  count: null
};

const initialStateDelete = {
  isLoading: false,
  data: [],
  error: null,
  count: null
};

//Get Order action
export const getOrdersAction = createAsyncThunk<any, any>(
  'get/orders',
  async (data, thunkApi) => {
    console.log('data', data);
    try {
      const urlWithParams =
        data.status && data.status !== 'ALL'
          ? `${URLs.GET_ORDERS}pageNo=${data.pageNo}&pageSize=${data.pageSize}&status=${data.status}`
          : `${URLs.GET_ORDERS}pageNo=${data.pageNo}&pageSize=${data.pageSize}`;
      const response = await axiosInstance({
        method: 'GET',
        url: urlWithParams,
        data
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

//Orders count action
export const getOrdersCountAction = createAsyncThunk<any>(
  'get/orders/count',
  async (_, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'GET',
        url: URLs.GET_ORDER_COUNT
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

//Excel upload action
export const addExcel = createAsyncThunk<any, any>('addexcel', async (data, thunkApi) => {
  console.log(data, 69);
  try {
    const formData = new FormData();
    if (data) {
      formData.append('file', data);
    }
    let response = await axiosInstance({
      method: 'POST',
      url: `${deliveryTrackingURLs.ADD_EXCEL}`,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: formData
    });
    thunkApi.dispatch(
      updateToast({
        show: true,
        message: response?.data?.message,
        severity: 'success'
      })
    );
    return response?.data?.data;
  } catch (error: any) {
    console.log(error, 92);
    thunkApi.dispatch(
      updateToast({
        show: true,
        message: error.response.data?.message,
        severity: 'error'
      })
    );
    return thunkApi.rejectWithValue(error);
  }
});

//Add Orders action
export const addOrders = createAsyncThunk<any, any>(
  'add/order',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'POST',
        url: `${URLs.ADD_ORDER}`,
        data: data
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: 'Order added successfully',
          severity: 'success'
        })
      );
      // await thunkApi.dispatch(getOrdersAction());
      return response;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

//Update Orders action
export const updateOrders = createAsyncThunk<any, any>(
  'update/order',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'POST',
        url: `${URLs.ADD_ORDER}`,
        data: data
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: 'Order added successfully',
          severity: 'success'
        })
      );
      // await thunkApi.dispatch(getOrdersAction());
      return response;
    } catch (error: any) {
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: error?.response?.data?.message,
          severity: 'error'
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);
//Delete Order action
export const deleteOrder = createAsyncThunk<any, any>(
  'delete/order',
  async (data, thunkApi) => {
    try {
      const response = await axiosInstance({
        method: 'DELETE',
        url: `${URLs.DELETE_ORDER}?assignedOrderId=${data}`
      });
      thunkApi.dispatch(
        updateToast({
          show: true,
          message: response?.data?.message,
          severity: 'success'
        })
      );
      return response?.data?.data;
    } catch (error: any) {
      if (error?.message !== 'canceled') {
        thunkApi.dispatch(
          updateToast({
            show: true,
            message: error?.response?.data?.message,
            severity: 'error'
          })
        );
      }
      return thunkApi.rejectWithValue(error);
    }
  }
);

//------Slices------//

//Get order Slice
const getOrders = createSlice({
  name: 'get orders',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getOrdersAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOrdersAction.fulfilled, (state, action: PayloadAction<any>) => {
        console.log('action payload', action?.payload);
        state.isLoading = false;
        state.data = action.payload?.data.data;
        state.error = null;
        state.count = action?.payload?.data?.data?.count;
      })
      .addCase(getOrdersAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload.response?.data?.error || 'Something went wrong';
      });
  }
});

//orders count slice
const getOrdersCount = createSlice({
  name: 'get orders count',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getOrdersCountAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOrdersCountAction.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.data = action.payload?.data.data;
        state.error = null;
      })
      .addCase(getOrdersCountAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload.response?.data?.error || 'Something went wrong';
      });
  }
});

//excel upload slice

const addExcelSlice = createSlice({
  name: 'add excel',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(addExcel.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addExcel.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.data = action.payload?.data?.data;
        state.error = null;
      })
      .addCase(addExcel.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action?.payload?.response?.data?.error || 'Something went wrong';
      });
  }
});

//Add order Slice

const addOrderSlice = createSlice({
  name: 'addorder',
  initialState: initialStateAddOrder,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getOrdersAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOrdersAction.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getOrdersAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload.response?.data?.error;
      });
  }
});

//update order Slice

const updateOrderSlice = createSlice({
  name: 'updateorder',
  initialState: initialStateAddOrder,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getOrdersAction.pending, state => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOrdersAction.fulfilled, (state, action: PayloadAction<any>) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(getOrdersAction.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action.payload.response?.data?.error;
      });
  }
});

//Delete Order Slice
const deleteOrderSlice = createSlice({
  name: 'deleteOrder',
  initialState: initialStateDelete,
  reducers: {},
  extraReducers: builder => {
    builder

      // delete Driver:
      .addCase(deleteOrder.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteOrder.fulfilled, (state, action: any) => {
        state.isLoading = false;
        state.error = null;
      })
      .addCase(deleteOrder.rejected, (state, action: any) => {
        state.isLoading = false;
        state.error = action?.payload?.response?.data?.error || 'Something went wrong';
      });
  }
});

export const getOrdersSlice = getOrders.reducer;
export const getOrdersCountSlice = getOrdersCount.reducer;
export const addExcelReducer = addExcelSlice.reducer;
export const addOrderReducer = addOrderSlice.reducer;
export const deleteOrderReducer = deleteOrderSlice.reducer;
